import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    jwt: ""
  },
  mutations: {
    setJwt(state, jwt) {
      state.jwt = jwt;

      if (jwt === "") {
        Vue.$cookies.remove("token");
      } else {
        Vue.$cookies.set("token", jwt);
      }
    }
  },
  actions: {
    setJwt(context, jwt) {
      context.commit("setJwt", jwt);
    }
  },
  modules: {},
  getters: {
    getJwt: state => {
      return state.jwt;
    },
    getRole: () => {
      return Vue.$cookies.get("role");
    }
  }
});
